<template>
  <div class="main common-table-cnt search">
    <el-form :inline="true" :model="formInline" class=" demo-form-inline">
      <el-form-item :label="$t('mechanism')" label-width="90px">
        <el-select
          ref="paramOuSelect"
          v-model="formInline.ouName"
          style="width:auto"
          :placeholder="$t('peaseSelect')"
          :popper-append-to-body="false"
          @change="changeParamOu"
          clearable
          @visible-change="visibleChange"
        >
          <el-option :value="formInline.ouName" style="height:auto;padding:0px">
            <el-tree
              ref="paramOuTree"
              node-key="id"
              default-expand-all
              highlight-current
              :expand-on-click-node="false"
              :data="ouList"
              :props="defaultProps"
              @node-click="selectParamOu"
            >
            </el-tree>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('loginUserName')">
        <el-input v-model="formInline.loginUserName" clearable :placeholder="$t('loginUserName')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('remoteUserName')">
        <el-input v-model="formInline.remoteUserName" clearable :placeholder="$t('remoteUserName')"></el-input>
      </el-form-item>

      <el-form-item :label="$t('sendDate')" class="datetime">
        <el-date-picker
          v-model="formInline.sendDateBegin"
          :placeholder="$t('startDate')"
          type="date"
          value-format="yyyy-MM-dd"
          popper-class="date-picker-blue-hw"
          :clearable="true"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item :label="$t('TO')">
        <el-date-picker
          v-model="formInline.sendDateEnd"
          :placeholder="$t('endDate')"
          type="date"
          value-format="yyyy-MM-dd"
          popper-class="date-picker-blue-hw"
          :clearable="true"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item :label="$t('updatedTime')" class="datetime">
        <el-date-picker
          v-model="formInline.handleDateBegin"
          :placeholder="$t('startDate')"
          type="date"
          value-format="yyyy-MM-dd"
          popper-class="date-picker-blue-hw"
          :clearable="true"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item :label="$t('TO')">
        <el-date-picker
          v-model="formInline.handleDateEnd"
          :placeholder="$t('endDate')"
          type="date"
          value-format="yyyy-MM-dd"
          popper-class="date-picker-blue-hw"
          :clearable="true"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item :label="$t('handleStatus')">
        <el-select
          v-model="formInline.status"
          clearable
          :placeholder="$t('handleStatus')"
          :popper-append-to-body="false"
        >
          <el-option v-for="item of fileType" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" class="serachBtn" @click="getList" v-preventReClick="1000">{{
          $t('query')
        }}</el-button>
        <el-button
          type="primary"
          class="serachBtn letter_delet"
          v-has="'sys:new:setting:log:data:delete'"
          @click="handleDelet"
          v-preventReClick="1000"
          >{{ $t('batchDelete') }}</el-button
        >
        <el-button type="primary" @click="exportList" :loading="exportLoading" class="serachBtn">{{
          $t('exportButton')
        }}</el-button>
      </el-form-item>
    </el-form>
    <!-- table 组件 -->
    <Table
      v-loading="loading"
      :data="tableData"
      :tableHeight="585"
      :columns="columns"
      :operation="dateOperation"
      :type="type"
      ref="tanleAssembly" 
      @getList="getList"
      @operate="operationEvent"
      :currentPage="currentPage"
      :pageSize="pageSize"
      :operationWidth="100"
      @sortChange="handleSort"
    ></Table>
    <el-pagination
      class="pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :pager-count="5"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalData"
    >
    </el-pagination>
  </div>
</template>

<script>
// 引入table组件
import Table from '@/components/table'
// 引入接口
import { getEmergencyHelp, deleteEmergencyHelpLog } from '@/api/log'
import { getOus } from '@/api/UserList'
import { getExportEmergency } from '@/api/log/log'
import { downloadBlobExcel } from '@/util/common'
import { beforeWeekDate, nowDate, getDaysDiff } from '@/util/date'
export default {
  name: 'GeoFenceRecord',
  props: {
    // 实时监控》历史记录》组件弹窗传用户名
    userId: {
      type: String,
    },
  },
  data() {
    return {
      ouList: [],
      tableHeight: 545,
      // 表单查询字段
      formInline: {
        ouName: '',
        ouId: '',
        loginUserName: '',
        sendDateBegin: beforeWeekDate(),
        sendDateEnd: nowDate(),
        handleDateBegin: '',
        handleDateEnd: '',
        remoteUserName: '',
        status: '',
      },
      // 当前页
      currentPage: 1,
      // 当前 条/页
      pageSize: 10,
      // 所有数据总条数
      totalData: 0,
      // table 表头数组
      columns: [],
      // table 操作栏数组
      dateOperation: [],
      // table 数据
      tableData: [],
      // 处理状态 选择
      fileType: [
        { label: this.$t('sendFail'), value: '-1' },
        { label: this.$t('notHandle'), value: '0' },
        { label: this.$t('videoHandle'), value: '1' },
        // { label:  this.$t('voiceHandle'), value: '2' },
        { label: this.$t('refuse'), value: '3' },
      ],
      // 用于批量删除 公共组件类型判断
      type: 'emergencyHelp',
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      exportLoading: false,
      showTip: false,
      // 遮罩层
      loading: false,
    }
  },
  components: {
    Table,
  },
  methods: {
    //导出列表
    exportList() {
      if (this.totalData >= 100000) {
        this.$message({
          type: 'warning',
          message: this.$t('maxFile'), //提示用户数据量过大，无法导出
        })
        return
      }
      this.exportLoading = true
      let params = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        ouId: this.formInline.ouId,
        ouName: this.formInline.ouName,
        sendDateBegin: this.formInline.sendDateBegin,
        sendDateEnd: this.formInline.sendDateEnd,
        loginUserName: this.formInline.loginUserName,
        handleDateBegin: this.formInline.handleDateBegin,
        handleDateEnd: this.formInline.handleDateEnd,
        remoteUserName: this.formInline.remoteUserName,
        status: this.formInline.status,
        sortColName: this.formInline.sortColName,
        useAsc: this.formInline.useAsc,
      }
      getExportEmergency(params).then(res => {
        this.exportLoading = false
        downloadBlobExcel(res, this.$t('OneClickHelprecord') + '.xls')
      })
    },
    // 排序
    handleSort(data) {
      this.formInline.sortColName = !data.order ? null : data.prop
      this.formInline.useAsc = data.order === 'descending' ? 0 : 1
      this.getList()
    },
    // 选中过滤条件机构，过滤用户
    selectParamOu(data) {
      this.formInline.ouName = data.name
      this.formInline.ouId = data.id
      this.$refs.paramOuSelect.blur()
    },
    // 获取组织机构
    getOusTree() {
      getOus().then(res => {
        if (res.state === 0) {
          this.ouList = res.data
        }
      })
    },
    // 机构查询 滚动条置顶
    visibleChange(val) {
      this.$nextTick(() => {
        let ele = document.querySelector('.el-select-dropdown__wrap')
        ele.scrollTop = ele.scrollHeight
      })
    },
    // 清空过滤条件机构，过滤用户
    changeParamOu(data) {
      if (!data) {
        this.formInline.ouId = null
        this.formInline.ouName = null
        this.$nextTick(() => {
          this.$refs.paramOuTree.setCurrentKey(null)
        })
      }
    },
    // 批量删除
    handleDelet() {
      this.$refs.tanleAssembly.handleDeletList()
    },
    // 操作按钮
    operationEvent(row, value, index) {
      if (row.type === 'delect') {
        this._delectEmergencyHelpLog(row)
      }
    },
    // 删除一键求助日志
    _delectEmergencyHelpLog(row) {
      this.$confirm(this.$t('deleteTip'), {
        confirmButtonText: this.$t('determine'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
        closeOnClickModal: false,
      }).then(() => {
        let params = {
          id: row.value.id,
        }
        deleteEmergencyHelpLog(params).then(res => {
          if (res.state === 0) {
            this.$message({
              type: 'success',
              message: this.$t('deleteSuccess'),
            })
            this.basicConfig()
          }
        })
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.basicConfig()
      // 清空批量选择的数据
      this.$refs.tanleAssembly.handleSelectionEmpty()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.basicConfig()
      this.$refs.tanleAssembly.handleSelectionEmpty()
    },
    // 查询
    getList() {
      this.$refs.tanleAssembly.handleSelectionEmpty()
      this.currentPage = 1
      this.handleSearch()
    },
    handleSearch() {
      let daysDiff = getDaysDiff(this.formInline.sendDateBegin, this.formInline.sendDateEnd)
      if (!this.showTip && daysDiff > 30) {
        this.$confirm(this.$t('searchDataTip'), {
          confirmButtonText: this.$t('determine'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning',
          closeOnClickModal: false,
        })
          .then(() => {
            this.basicConfig()
            this.showTip = true
          })
          .catch(() => {
            this.showTip = false
            return
          })
      } else {
        this.basicConfig()
      }
    },
    // 基础配置数据
    basicConfig() {
      this.loading = true
      let param = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        ouId: this.formInline.ouId,
        ouName: this.formInline.ouName,
        sendDateBegin: this.formInline.sendDateBegin,
        sendDateEnd: this.formInline.sendDateEnd,
        loginUserName: this.formInline.loginUserName,
        handleDateBegin: this.formInline.handleDateBegin,
        handleDateEnd: this.formInline.handleDateEnd,
        remoteUserName: this.formInline.remoteUserName,
        status: this.formInline.status,
        sortColName: this.formInline.sortColName,
        useAsc: this.formInline.useAsc,
      }
      // 获取一件求助数据
      getEmergencyHelp(param).then(res => {
        if (res.state === 0) {
          this.loading = false
          // 遍历循环 判断status的传输代表的文字
          res.value.list.forEach((item, index) => {
            // 根据状态对应字体
            switch (item.status) {
              case -1:
                item.status = this.$t('sendFail')
                break
              case 0:
                item.status = this.$t('notHandle')
                break
              case 1:
                item.status = this.$t('videoHandle')
                break
              case 2:
                item.status = this.$t('voiceHandle')
                break
              default:
                item.status = this.$t('refuse')
                break
            }
          })
          this.tableData = res.value.list
          this.totalData = res.value.total
        }
      })
      // table 表头配置数据
      this.columns = [
        {
          attrName: 'ouName',
          label: this.$t('mechanism'),
          sort: 'ouName',
        },
        {
          attrName: 'loginUserName',
          label: this.$t('loginUserName'),
          sort: 'loginUserName',
        },
        {
          attrName: 'operationIp',
          label: this.$t('loginUserIP'),
          sort: 'operationIp',
        },
        {
          attrName: 'remoteUserName',
          label: this.$t('remoteUserName'),
          sort: 'remoteUserName',
        },
        {
          attrName: 'status',
          label: this.$t('handleStatus'),
          align: 'center',
          width: '140',
          sort: 'status',
        },
        {
          attrName: 'sendTimestamp',
          label: this.$t('sendDate'),
          align: 'center',
          width: '180',
          sort: 'sendTimestamp',
        },
        {
          attrName: 'handleTimestamp',
          label: this.$t('updatedTime'),
          align: 'center',
          width: '180',
          sort: 'handleTimestamp',
        },
      ]
      // table 操作栏配置
      this.dateOperation = [
        {
          operateName: '',
          icon: require('@/icon/new-common/icon_delete.png'),
          type: 'delect',
          IsHad: '',
        },
      ]
    },
  },
  created() {
    this.basicConfig()
    this.getOusTree()
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/new-set-common.styl';

>>>.el-table {
  height: 630px !important;
  min-height: 500px !important; /* no */
  overflow: auto;
}
>>> .el-tree-node__content
  font-weight: 400
  color: var(--new-el-select-dropdown-item)

.letter_delet {
  margin-left: 10px;
}

>>>.el-popper {
  min-width: 100% !important;
}
</style>
